import { forwardRef } from 'react'

import { useReactNodeView } from '../ReactNodeView/ReactNodeViewContext'

export const ExampleParagraph = forwardRef<HTMLDivElement, any>(({ children }, contentDomRef) => {
  const context = useReactNodeView()
  return (
    <p>
      <div contentEditable={false}>Here's the text of the node: {context.node?.textContent}</div>
      <div ref={contentDomRef} />
      {children}
    </p>
  )
})
